module.exports = __webpack_public_path__ + "media/images/lb/227-c6292d11eb83b741e3fc3e5a49c292d2.svg";